import Config from '../../config';
import authEndpoints from './authEndpoints';
import apiClient from '../apiClient';

interface CreatePasswordProps {
  email: string;
  name: string;
  password: string;
  code: string;
}

export const createPassword = async ({
  email,
  name,
  password,
  code,
}: CreatePasswordProps): Promise<axios.AxiosResponse | void> => {
  const { API_URL } = Config;
  const response = await apiClient.post(
    `${API_URL}${authEndpoints.CreatePasswordEndpoint}`,
    { email, name, password, code },
    {
      withCredentials: true,
    },
  );
  return response;
};
